import { SEARCHED_LOCATION } from '@location/actionTypes';
import { errorAction } from '@shared/actions';
import getSearchedLocation from '@location/selectors/getSearchedLocation';
import {
  getLocationPointWithGuessedType,
  getLocationPointCity,
} from '@commons/models/LocationPoint';
import setLocationPointCity from '@commons/models/LocationPoint/setters/setCity';
import { getLocationCity } from '@services/location.service';
import dispatchSearchedLocation from '@location/actions/dispatchSearchedLocation';
import { getCountryId } from '@shared/selectors';

const type = SEARCHED_LOCATION;
const errorMessage = 'No location parameter in getSearchedLocationWithCity.';

function shouldUpdateLocation(x, y) {
  return x !== y;
}

/**
 * If we want to be sure that location has city, we should use this method in our action.
 * @param {*} newLocation New searched location by user.
 * @param {*} muteError Boolean to mute error action.
 * @param {*} saveSync Boolean if location should be dispatched before getting it's city.
 */
const getSearchedLocationWithCity = ({
  newLocation,
  muteError = true,
} = {}) => async (dispatch, getState) => {
  try {
    const actualSearchedLocation = getSearchedLocation(getState());
    let location =
      getLocationPointWithGuessedType(newLocation) || actualSearchedLocation;

    if (!location) throw new Error(errorMessage);

    const countryId = getCountryId(getState());
    location.countryId = countryId;

    if (!getLocationPointCity(location)) {
      const { success, data } = await getLocationCity(location);
      if (success) {
        const { city } = data;
        location = setLocationPointCity({ location, city });
      }
    }

    if (shouldUpdateLocation(actualSearchedLocation, location)) {
      await dispatch(dispatchSearchedLocation(location));
    }

    return location;
  } catch (error) {
    dispatch(errorAction({ error, type, mute: muteError }));
    return null;
  }
};

export default getSearchedLocationWithCity;
